import { type EChartsExtensionInstallRegisters } from 'echarts/lib/extension';
import Axis from 'echarts/lib/coord/Axis';
import type AxisModel from 'echarts/types/src/coord/cartesian/AxisModel';
import type { Group } from 'zrender';

/**
 * * 为轴提供一个内边距配置项 `dvPadding`
 */
// eslint-disable-next-line @typescript-eslint/unbound-method
const originSetExtentMethod = Axis.prototype.setExtent;

Axis.prototype.setExtent = function (start: number, end: number, ...rest) {
  const dvPadding = this?.model?.get('dvPadding') as [number, number];
  if (typeof dvPadding !== 'undefined') {
    start += this.inverse ? -dvPadding[0] : dvPadding[0];
    end -= this.inverse ? -dvPadding[1] : dvPadding[1];
  }

  originSetExtentMethod.call(this, start, end, ...rest);
};

function installDvPadding(registers: EChartsExtensionInstallRegisters) {
  /**
   * ! 由于实现轴的内边距时修改了 extent 范围，在视觉效果上依然需要达到轴线和 grid 边对齐
   */
  registers.registerUpdateLifecycle('afterupdate', (ecModel, api) => {
    ecModel.eachComponent((compType, compModel: AxisModel) => {
      if (compType !== 'xAxis' && compType !== 'yAxis') {
        return;
      }

      const dvPadding: [number, number] = compModel.option;
      if (typeof dvPadding === 'undefined') {
        return;
      }

      const gridRect = compModel.getCoordSysModel().coordinateSystem.getRect();
      const compView = api.getViewOfComponentModel(compModel);

      (compView.group as Group)?.traverse(childEl => {
        if (childEl.anid !== 'line') {
          return;
        }

        // ! 丢失轴线动画
        childEl.stopAnimation(null, true);
        if (compType === 'xAxis') {
          childEl.attr({
            shape: {
              x1: gridRect.x,
              x2: gridRect.x + gridRect.width
            }
          });
        } else {
          childEl.attr({
            shape: {
              y1: gridRect.y,
              y2: gridRect.y + gridRect.height
            }
          });
        }
      });
    });
  });
}

export function install(registers: EChartsExtensionInstallRegisters) {
  installDvPadding(registers);
}
